import { connect } from 'react-redux';

import { getGoLiveSectionProps } from '../../selectors';
import GoLiveSection from './GoLiveSection';

export default connect(getGoLiveSectionProps)(GoLiveSection);
